import React, { useState } from "react";
import { Link } from "gatsby";

const Header = () => {
  const [state, setstate] = useState(false);
  return (
    <>
      <header className="bg-white shadow-sm">
        <div className="container mx-auto p-2 md:p-0 md:px-2 flex flex-col md:flex-row md:items-center">
          <div className="logo-wrapper flex justify-between items-center w-full">
            <Link
              to="/"
              className="logo text-3xl font-semibold mr-2 flex items-center hover:underline hover:text-purple-600"
            >
              Receipt Maker
            </Link>
            <div className="toggle-button md:hidden">
              <button
                onClick={() => setstate(!state)}
                id="toggleNav"
                aria-label="toggole your navbar"
                className="focus:outline-none"
              >
                <i
                  className={`demo-icon ${
                    !state ? "icon-menu" : "icon-cancel"
                  } text-2xl`}
                ></i>
              </button>
            </div>
          </div>
          <div
            className={`${
              !state ? "hidden" : null
            } nav w-full md:flex flex-col md:flex-row md:justify-end md:items-center`}
          >
            <nav className="font-semibold md:flex">
              <Link
                className="block hover:bg-gray-100 hover:text-purple-600 p-2 md:px-3 md:py-4"
                to="/how-to/"
              >
                How to
              </Link>
              <div className="links flex items-center font-semibold p-2 md:py-0">
                <a
                  className="border border-gray-400 hover:border-gray-500 rounded px-3 py-1 mr-4"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://twitter.com/intent/tweet?text= Generate your business receipt with https://receiptmaker.netlify.app/ (via @maikap_dipankar)"
                >
                  <i className="demo-icon icon-twitter mr-1 text-lg"></i>
                  Tweet
                </a>
                <a
                  className="border border-gray-400 hover:border-gray-500 rounded px-3 py-1"
                  href="mailto:dipankarmaikap77@gmail.com?subject=Quote for a project&body"
                >
                  <i className="demo-icon icon-code mr-1 text-lg"></i>
                  Hire me
                </a>
              </div>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
